'use client';

import { useEffect, useState } from 'react';
import { useScrollContainer } from '@/app/_lib/providers/ScrollProvider';

export function FloatingBackToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollContainerRef } = useScrollContainer();

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
        if (scrollContainer.scrollTop > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      }
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      // Check initial scroll position
      toggleVisibility();

      scrollContainer.addEventListener('scroll', toggleVisibility);

      return () => scrollContainer.removeEventListener('scroll', toggleVisibility);
    }
  }, [scrollContainerRef]);

  const scrollToTop = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <button
      type='button'
      onClick={scrollToTop}
      className={`fixed bottom-8 right-8 z-9999 p-4 rounded-full bg-primary hover:bg-primary-dark dark:bg-primary-light dark:hover:bg-primary text-white dark:text-gray-900 shadow-lg hover:shadow-xl transform transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'
      } hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-primary-light`}
      aria-label='Back to top'
    >
      <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 10l7-7m0 0l7 7m-7-7v18' />
      </svg>
    </button>
  );
}
